import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { Invoice } from '../../invoice/invoice';
import { InvoiceService } from '../../invoice/invoice.service';
import { InvoiceListPipe } from '../../pipe/invoicelist.pipe';

@Component({
  selector: 'app-unpaid-invoices',
  templateUrl: './unpaid-invoices.component.html',
  styleUrls: ['./unpaid-invoices.component.css']
})
export class UnpaidInvoicesComponent implements OnInit {

  serchText: string='';
  page=1;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  totalrecord:number;
  submitted = false;
  message: string;	
  invoice = new Invoice();
  invoices: Invoice[];
  invoiceFilter: any = { invoiceno: '' };
  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
    ) { }

  ngOnInit() {
	  this.getUnpaidInvoices();
  }
  getUnpaidInvoices() {
    return this.invoiceService.getUnpaidInvoices()
               .subscribe(
                invoices => {
                  this.invoices = invoices;
				          this.totalrecord =this.invoices.length;
                 }
                );
 }

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}
}
